export const isPhone = process.env.NEXT_PUBLIC_TERMINAL === 'm';